import React from 'react'
import clsx from 'clsx'

export default function UserLabel({
    name,
    email,
    headline,
    avatarUrl,
    size = 36,
    className,
    truncate = true,
}: {
    name?: string | null
    email: string
    headline?: string | null
    avatarUrl?: string
    size?: number
    className?: string
    truncate?: boolean
}): React.JSX.Element {
    const displayName = (name && name.trim()) || email
    const showEmail =
        !!email && displayName.toLowerCase() !== email.toLowerCase()

    const imgSrc = avatarUrl || '/no-profile-pic.svg'

    return (
        <div className={clsx('flex items-center gap-3 min-w-0', className)}>
            <img
                src={imgSrc}
                alt={displayName}
                style={{ width: size, height: size }}
                className="rounded-full object-cover shrink-0"
                onError={(e) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = '/no-profile-pic.svg'
                }}
            />
            <div className="min-w-0">
                <div
                    className={clsx(
                        'text-sm font-medium',
                        truncate && 'truncate',
                        'font-semibold',
                    )}
                >
                    {displayName}
                </div>
                {showEmail && (
                    <div
                        className={clsx(
                            'text-xs text-gray-500',
                            truncate ? 'truncate' : 'break-all',
                        )}
                    >
                        {email}
                    </div>
                )}
                {headline && (
                    <div
                        className={clsx(
                            'text-xs text-gray-600 truncate',
                            truncate ? 'truncate' : 'break-all',
                        )}
                    >
                        {headline}
                    </div>
                )}
            </div>
        </div>
    )
}
